<template>
  <div class="dashboard-datasets-chips">
    <div
      class="dashboard-datasets-chips__item"
      v-for="(item, index) in combinedData"
      :key="index"
      :title="item.label">
      <div class="dashboard-datasets-chips__item-heading">
        <div class="dashboard-datasets-chips__item-label-wrapper">
          <span class="dashboard-datasets-chips__item-color-bullet"></span>
          <span class="dashboard-datasets-chips__item-label">{{ item.label }}</span>
        </div>
        <button
          v-show="index !== 0"
          class="dashboard-datasets-chips__item-close"
          @click="() => $emit('remove-dataset-item', index)"></button>
      </div>
      <!-- <div
        class="dashboard-datasets-chips__item-data"
        :style="{ color: chipDataColoringRule(calculatePeriodAverage(item)) }">
        {{ calculatePeriodAverage(item) | formatAveragePercentage }}
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'dashboard-datasets-chips',
  props: {
    datasets: {
      type: Array,
      required: true,
    },
    datasetGeral: {
      type: Array,
      required: true,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    chipDataColoringRule: {
      type: Function,
    },
  },
  computed: {
    combinedData() {
      return [
        ...this.datasetGeral,
        ...this.datasets,
      ];
    },
  },
  filters: {
    formatAveragePercentage(val) {
      return `${val.toFixed(1).replace('.', ',')}%`;
    },
  },
  methods: {
    calculatePeriodAverage(dataset) {
      const periods = dataset.valuesByPeriod;
      const values = Object.values(periods);

      const sum = values.reduce((acc, val) => {
        const value = this.parseNumberString(val);
        return (parseFloat(acc) + value).toFixed(1);
      }, 0);

      return sum / values.length;
    },
    parseNumberString(strNumber) {
      return parseFloat(strNumber.replace(',', '.'));
    },
  },
};
</script>

<style lang="scss" scoped>
$dataset-color-1: #6a0035;
$dataset-color-1--dark: #4e062a;
$dataset-color-1--light: #6a003580;

$dataset-color-2: #029DFF;
$dataset-color-2--dark: #134667;
$dataset-color-2--light: #049DFA80;

$dataset-color-3: #FFCA3A;
$dataset-color-3--dark: #6F591D;
$dataset-color-3--light: #FFCA3A80;

$dataset-color-4: #9856F4;
$dataset-color-4--dark: #503B6C;
$dataset-color-4--light: #9856F480;

$dataset-color-5: #8AC926;
$dataset-color-5--dark: #4D6E19;
$dataset-color-5--light: #8AC92680;

$dataset-color-6: #FF009D;
$dataset-color-6--dark: #6A0035;
$dataset-color-6--light: #FF009D80;

.dashboard-datasets-chips {
  display: flex;
  flex-wrap: nowrap;
  .dashboard-datasets-chips__item {
    &:nth-child(1) {
      --dataset-color: #{$dataset-color-1};
      --dataset-color--dark: #{$dataset-color-1--dark};
      --dataset-color--light: #{$dataset-color-1--light};
    }
    &:nth-child(2) {
      --dataset-color: #{$dataset-color-2};
      --dataset-color--dark: #{$dataset-color-2--dark};
      --dataset-color--light: #{$dataset-color-2--light};
    }
    &:nth-child(3) {
      --dataset-color: #{$dataset-color-3};
      --dataset-color--dark: #{$dataset-color-3--dark};
      --dataset-color--light: #{$dataset-color-3--light};
    }
    &:nth-child(4) {
      --dataset-color: #{$dataset-color-4};
      --dataset-color--dark: #{$dataset-color-4--dark};
      --dataset-color--light: #{$dataset-color-4--light};
    }
    &:nth-child(5) {
      --dataset-color: #{$dataset-color-5};
      --dataset-color--dark: #{$dataset-color-5--dark};
      --dataset-color--light: #{$dataset-color-5--light};
    }
    &:nth-child(6) {
      --dataset-color: #{$dataset-color-6};
      --dataset-color--dark: #{$dataset-color-6--dark};
      --dataset-color--light: #{$dataset-color-6--light};
    }
    flex-wrap: wrap;
    border: 2px solid var(--dataset-color--light);
    min-width: 136px;
    padding: .625rem .75rem;
    border-radius: 8px;
    &:not(:last-child) {
      margin-right: .5rem;
    }
    .dashboard-datasets-chips__item-heading {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      // margin-bottom: .5rem;
      .dashboard-datasets-chips__item-label-wrapper {
        display: flex;
        align-items: center;
        overflow: hidden;
        .dashboard-datasets-chips__item-color-bullet {
          display: block;
          min-width: 12px;
          min-height: 12px;
          border-radius: 50%;
          background-color: var(--dataset-color);
          margin-right: .625rem;
        }
        .dashboard-datasets-chips__item-label {
          font-size: .75rem;
          font-weight: 600;
          color: var(--dataset-color--dark);
          margin-right: .625rem;
          white-space: nowrap;
          overflow: hidden;
          max-width: calc(100% - 12px - .625rem);
          text-overflow: ellipsis;
        }
      }
      .dashboard-datasets-chips__item-close {
        display: block;
        width: 12px;
        height: 12px;
        background-color: transparent;
        border: none;
        position: relative;
        &::before,
        &::after {
          content: '';
          width: 100%;
          height: 2px;
          background-color: var(--dataset-color--dark);
          position: absolute;
          top: calc(50% - 1px);
          left: 0;
        }
        &::before { transform: rotate(-45deg); }
        &::after { transform: rotate(45deg); }
      }
    }
    .dashboard-datasets-chips__item-data {
      width: 100%;
      font-size: 1.125rem;
      font-weight: 600;
    }
  }
}

@include media-breakpoint-up(lg) {
  .dashboard-datasets-chips {
    width: 100%;
    .dashboard-datasets-chips__item {
      max-width: 20%;
      .dashboard-datasets-chips__item-heading {
        .dashboard-datasets-chips__item-label-wrapper {
          .dashboard-datasets-chips__item-label {
            font-size: .875rem;
          }
        }
      }
    }
  }
}
</style>
